/**
 * @module project/components/entry_details/entry_comment_modal
 */
import React, { PropTypes, Component } from 'react';
import { Field } from 'redux-form';
import Draggable from 'react-draggable';
import classnames from 'classnames';
import { TextAreaField } from 'common/components/form_fields';
import HorizontalSelector from 'common/components/horizontal_selector';

/**
 * Entry in-place comments adding modal form
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class EntryCommentModal extends Component {
  constructor(props) {
    super(props);

    this.state = { internal: props.canSendInternalOnly || false };

    this.sendComment = this.sendComment.bind(this);
    this.getSelectorOptions = this.getSelectorOptions.bind(this);
    this.getPlaceholder = this.getPlaceholder.bind(this);
  }

  sendComment(data) {
    const { internal } = this.state;
    const {
      commentsPosition, revision, entry, addInPlaceComment, onToggleModal,
      canSendInternal, canSendInternalOnly
    } = this.props;

    const formData = {
      body: data.comment,
      percent_x: commentsPosition.x,
      percent_y: commentsPosition.y,
      internal: false
    };

    if (canSendInternalOnly) {
      formData.internal = true;
    } else if (canSendInternal) {
      formData.internal = internal;
    }

    return addInPlaceComment(entry.entry_type, revision.id, formData)
    .then(onToggleModal);
  }

  getSelectorOptions() {
    const { canSendInternal, canSendInternalOnly } = this.props;
    let options = [];

    if (canSendInternal) {
      options = [{
        label: 'Internal note',
        value: true,
      }];

      if (!canSendInternalOnly) {
        options = [{
          label: 'Private comment',
          value: false
        }, ...options];
      }
    }

    return options;
  }

  getPlaceholder() {
    const { internal } = this.state;
    const { isClient, isCollaborator, hasCollaborators, commentReply } = this.props;

    if (commentReply) {
      return 'Add a reply...';
    }

    if (internal) {
      if (isClient) {
        return `Add an internal note for yourself${hasCollaborators? ' or collaborators' : ''}...`;
      }

      if (isCollaborator) {
        return 'Add an internal note for yourself, the client or other collaborators...';
      }

      return 'Add an internal note...';
    }

    if (isClient || isCollaborator) {
      return 'Add a private comment for the creative...';
    }

    return 'Add a private comment...';
  }

  render() {
    const { internal } = this.state;
    const { handleSubmit, position, submitting } = this.props;
    const selectorOpts = this.getSelectorOptions();

    return (
      <Draggable defaultPosition={position}>
        <div className={classnames("comments-dialog", { internal })}>
          <div className="modal-content inplace-comment-form">
            <form
              className="row"
              onSubmit={handleSubmit(this.sendComment)}
            >
              <fieldset className="small-16 column">
                { selectorOpts.length > 0 &&
                <HorizontalSelector options={selectorOpts} value={internal}
                  onSelect={v => this.setState({ internal: v })} /> }
                <Field name="comment" component={TextAreaField} placeholder={this.getPlaceholder()}
                  rows={3} />
              </fieldset>
              <div className="small-16 column form-buttons">
                <button
                  className="btn btn-tertiary submit"
                  type="submit"
                >{ submitting ? 'Adding...' : 'Add' }</button>
                <button
                  className="btn btn-text cancel"
                  type="button"
                  onClick={this.props.onToggleModal}
                >Cancel</button>
              </div>
            </form>
          </div>
        </div>
      </Draggable>
    );
  }
}

EntryCommentModal.propTypes = {
  position: PropTypes.object.isRequired,
  revision: PropTypes.object.isRequired,
  entry: PropTypes.object.isRequired,
  commentsPosition: PropTypes.object,
  handleSubmit: PropTypes.func,
  addInPlaceComment: PropTypes.func,
  onToggleModal: PropTypes.func,
  canSendInternal: PropTypes.bool,
  canSendInternalOnly: PropTypes.bool,
  isClient: PropTypes.bool,
  isCollaborator: PropTypes.bool,
  hasCollaborators: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./project/components/entry_details/entry_comment_modal.jsx